// Convert an array of [isoDateString, value] pairs into sorted Highcharts
// series data ([timestamp, float]), dropping unparseable rows. Both charts on
// the market breadth page run their data through this so the linked crosshair
// maps identical dates to identical timestamps.
export function toDateValueSeries(data) {
  if (!Array.isArray(data)) return []

  return data
    .map(item => {
      const date = new Date(item[0]).getTime()
      const value = parseFloat(item[1])
      return (!isNaN(date) && !isNaN(value)) ? [date, value] : null
    })
    .filter(point => point !== null)
    .sort((a, b) => a[0] - b[0])
}
